export default __webpack_public_path__ + "static/media/percent.a5791d5f.svg";